export default {
  // Page title
  title: "Registro de Envío",

  // Search form
  searchForm: {
    pushTime: "Hora de Envío",
    pushTimePlaceholder: "Por favor seleccione rango de tiempo",
    memberAccount: "Miembro de Envío",
    memberAccountPlaceholder: "Por favor ingrese",
    memberType: "Tipo de Miembro",
    memberTypePlaceholder: "Por favor seleccione",
    search: "Consultar",
    reset: "Restablecer"
  },

  // Table column titles
  table: {
    memberAccount: "Miembro de Envío",
    memberType: "Tipo de Miembro",
    pushTitle: "Título del Envío",
    pushContent: "Contenido del Envío",
    pushTime: "Hora de Envío",
    status: "Estado",
    createTime: "Hora de Creación"
  },

  // Member type
  memberType: {
    specify: "Miembros Especificados",
    agent: "Agente",
    import: "Importación de Documento",
    all: "Todos los Miembros"
  },

  // Status
  status: {
    pending: "Pendiente",
    success: "Envío Exitoso",
    failed: "Envío Fallido"
  },

  // Pagination
  pagination: {
    total: "Total {total} registros",
    pageInfo: "Página {currentPage}/{totalPages}",
    itemsPerPage: "elementos/página",
    jumpTo: "Ir a",
    page: "página"
  },

  // Messages
  messages: {
    fetchDataFailed: "Error al obtener datos",
    noData: "Sin datos",
    timeRangeExceeded: "El rango de tiempo de consulta no puede exceder 1 mes, por favor reseleccione."
  }
};
